import React from 'react'


export default class DropDownSep extends React.Component {

    render(){
        return (
            <div className="dropdown-2--sep"></div>
        )
    }

}